import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { ResetUserPassword } from "../../../Store/userSlice";
import logo from "../../../assets/images/logo.png";
import axios from "axios";
import "./ResetPass.css";

const passwordPattern = /^(?=.*[a-zA-Z])(?=.*\d).{6,}$/;

const ResetPass = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`/users/reset-password/token-verify/${token}`)
      .catch(() => navigate("/invalid-token"));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!passwordPattern.test(password)) {
      setError("Le mot de passe doit comporter au moins 6 caractères avec une lettre et un chiffre.");
      return;
    }
    if (confirmPassword !== password) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    setLoading(true);
    try {
      const result = await dispatch(ResetUserPassword({ newPassword: password, newPasswordToken: token }));
      if (result.payload?.status === 201) {
        setSuccess(true);
        setTimeout(() => navigate("/login"), 3000);
      } else {
        const msg = result.payload?.data?.message;
        if (Array.isArray(msg)) {
          setError(msg[0]);
        } else {
          setError(msg || "Une erreur est survenue. Veuillez réessayer.");
        }
      }
    } catch {
      setError("Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-page">
      <div className="reset-card">

        <NavLink to="/">
          <img src={logo} alt="Casa del Padel" className="reset-logo" />
        </NavLink>

        <h1 className="reset-title">Nouveau mot de passe</h1>
        <p className="reset-subtitle">Choisissez un mot de passe sécurisé pour votre compte.</p>

        {error && <div className="reset-error">{error}</div>}
        {success && (
          <div className="reset-success">
            Mot de passe modifié avec succès ! Redirection vers la connexion…
          </div>
        )}

        {!success && (
          <form className="reset-form" onSubmit={handleSubmit} noValidate>
            <div className="reset-field">
              <label className="reset-label" htmlFor="reset-password">
                Nouveau mot de passe
              </label>
              <div className="reset-input-wrap">
                <input
                  id="reset-password"
                  type={showPassword ? "text" : "password"}
                  className="reset-input"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => { setPassword(e.target.value); setError(""); }}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="reset-eye-btn"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? "Masquer" : "Afficher"}
                >
                  {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                </button>
              </div>
              <span className="reset-hint">Au moins 6 caractères avec une lettre et un chiffre.</span>
            </div>

            <div className="reset-field">
              <label className="reset-label" htmlFor="reset-confirm-password">
                Confirmer le mot de passe
              </label>
              <div className="reset-input-wrap">
                <input
                  id="reset-confirm-password"
                  type={showConfirmPassword ? "text" : "password"}
                  className="reset-input"
                  placeholder="••••••••"
                  value={confirmPassword}
                  onChange={(e) => { setConfirmPassword(e.target.value); setError(""); }}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="reset-eye-btn"
                  onClick={() => setShowConfirmPassword((v) => !v)}
                  aria-label={showConfirmPassword ? "Masquer" : "Afficher"}
                >
                  {showConfirmPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                </button>
              </div>
            </div>

            <button type="submit" className="reset-submit" disabled={loading}>
              {loading ? "Enregistrement…" : "Enregistrer le mot de passe"}
            </button>
          </form>
        )}

      </div>
    </div>
  );
};

export default ResetPass;
